export enum TeamLanguage {
  FR = 'fr_FR',
  EN = 'en_US',
}
